<!--  -->
<template>
  <div class="page" :class="{ inApp: $root.isApp || this.$root.miniprogram }">
    <common-title titleName="集训营" :zIndex="1000"></common-title>
    <div class="head">
      <h1>{{ classInfo.name }}</h1>
      <div class="info">
        <div class="name">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/icon5.png"
            alt
          />
          <span>{{ classInfo.teacherName }}</span>
        </div>
        <div class="phone">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/icon4.png"
            alt
          />
          <span>{{ classInfo.teacherPhone }}</span>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="list" v-if="classInfo.noticeFile" @click="openPdf">
        <div class="name">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/icon1.png"
            alt
          />
          <p>入营须知</p>
        </div>
        <img
          class="arrow"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/arrow.png"
          alt
        />
      </div>
      <div class="list" @click="openQuestionList" v-if="isComplete">
        <div class="name">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/icon1.png"
            alt
          />
          <p>问卷调研</p>
        </div>
        <img
          class="arrow"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/arrow.png"
          alt
        />
      </div>
      <div class="list" @click="openAgree">
        <div class="name">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/icon1.png"
            alt
          />
          <p>我的协议</p>
        </div>
        <img
          class="arrow"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/trainingCamp/arrow.png"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import {
  reqLearnSurveyComplete,
  reqClassInfo,
  reqQuestionnaireList,
} from '@/api/trainEntrance/index';

export default {
  components: {},
  data() {
    return {
      classInfo: {},
      isComplete: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getIsComplete() {
      const { classId } = this.$route.query;
      const { data } = await reqQuestionnaireList(classId);
      console.log(data, '问卷');
      this.isComplete = data && data.length > 0;
    },
    async getClassInfo() {
      const { classId } = this.$route.query;
      if (!classId) return;
      const { data } = await reqClassInfo(classId);
      this.classInfo = data || {};
    },
    openAgree() {
      this.$router.push({
        path: '/personalCenter/myAgreement',
        query: {},
      });
    },
    openQuestionnaire() {
      this.$router.push({
        path: '/questionnaire',
        query: {},
      });
    },
    openQuestionList() {
      const { classId } = this.$route.query;
      this.$router.push({
        path: 'questionnList',
        query: {
          classId,
        },
      });
    },
    openPdf() {
      const temp = this.classInfo.noticeFile;
      const url = JSON.parse(temp)?.url;
      console.log(url, temp, 111111);
      if (this.$root.isApp) {
        this.$sendToApp('goPdf', { url, title: '入营须知' }, false);
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/professionalCourseBank/openPdfFile/openPdfFile?pdfUrl=${url}&fileName=${decodeURIComponent(
            '入营需知',
          )}`,
        });
        return;
      }
      window.open(url);
    },
  },
  created() {},
  mounted() {
    document.title = '集训营';
    this.getIsComplete();
    this.getClassInfo();
  },
};
</script>
<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}
.page {
  width: 100%;
  height: 100%;
  padding-top: 101px;
  padding-bottom: 210px;
  background: #f9f9f9;
  .head {
    padding: 36px;
    background: #fff;
    h1 {
      padding-bottom: 21px;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      line-height: 43px;
      word-break: break-all;
    }
    .info {
      display: flex;
      align-items: center;

      .name {
        display: flex;
        align-items: center;
        margin-right: 72px;
        img {
          width: 29px;
          height: 29px;
          border-radius: 50%;
        }
        span {
          color: #999;
          font-weight: 400;
          font-size: 24px;
        }
      }
      .phone {
        display: flex;
        align-items: center;
        img {
          width: 29px;
          height: 29px;
        }
        span {
          color: #999;
          font-weight: 400;
          font-size: 24px;
        }
      }
    }
  }
  .section {
    padding: 31px 36px;
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 109px;
      margin-bottom: 22px;
      padding: 22px;
      background: #fff;
      border-radius: 14px;
      .name {
        display: flex;
        align-items: center;
        img {
          width: 65px;
          height: 65px;
        }
        p {
          margin-left: 25px;
          color: #333;
          font-weight: 500;
          font-size: 25px;
        }
      }
      .arrow {
        width: 43px;
        height: 43px;
      }
    }
  }
}
</style>
